import React from 'react';
import { useTranslation } from 'react-i18next';
import { useIsMobile } from 'Hooks';
import { Icon } from 'Components';
import styles from './TemplateListCard.module.scss';

export interface TemplateListItemData {
  id: number | string;
  title: string;
  languagesCount: number;
  difficulty?: string;
  img_path?: string;
}

interface TemplateListCardProps {
  data: TemplateListItemData;
  onReview: (id: number | string) => void;
  onEdit?: (id: number | string) => void;
  isSuperAdmin?: boolean;
}

const FALLBACK_THUMBNAIL = 'https://placehold.co/24x24';

export const TemplateListCard: React.FC<TemplateListCardProps> = ({
  data,
  onReview,
  onEdit,
  isSuperAdmin = true
}) => {
  const { t } = useTranslation();
  const isMobile = useIsMobile();

  const handleReviewClick = () => {
    onReview(data.id);
  };

  const handleEditClick = () => {
    if (onEdit) {
      onEdit(data.id);
    } else {
      onReview(data.id);
    }
  };

  return (
    <div className={styles.cardContainer}>
      <div className={styles.thumbnailWrapper}>
        <img
          src={data.img_path || FALLBACK_THUMBNAIL}
          alt={data.title}
          className={styles.thumbnailImage}
        />
      </div>

      <div className={styles.contentWrapper}>
        <div className={styles.titleRow}>
          <span className={styles.templateTitle} title={data.title}>
            {data.title}
          </span>
        </div>
        <div className={styles.languageCount}>
          {data.languagesCount}{' '}
          {data.languagesCount === 1
            ? t('phishingTemplateManager.language')
            : t('phishingTemplateManager.languages')}
        </div>
      </div>

      <div className={styles.actionsWrapper}>
        <button
          type="button"
          onClick={handleReviewClick}
          className={styles.detailsButton}
        >
          <span className={styles.detailsButtonText}>
            {t('phishingTemplateManager.details')}
          </span>
        </button>

        {isSuperAdmin && !isMobile && (
          <div className={styles.adminActionGroup}>
            <div className={styles.divider} />
            <button
              type="button"
              onClick={handleEditClick}
              className={styles.editButton}
              title={t('phishingTemplateManager.prefilledForm.editTemplateTitle')}
            >
              <Icon type="editPencil" />
            </button>
          </div>
        )}
      </div>
    </div>
  );
};

export default TemplateListCard;